<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    fill="currentColor"
    d="M24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0ZM31.0585 16.943C31.0585 20.8415 27.8981 24.0019 23.9996 24.0019C20.1012 24.0019 16.9408 20.8415 16.9408 16.943C16.9408 13.0445 20.1012 9.88421 23.9996 9.88421C27.8981 9.88421 31.0585 13.0445 31.0585 16.943ZM12.7055 32.8262C12.7055 29.5125 15.3918 26.8262 18.7055 26.8262H29.2938C32.6075 26.8262 35.2938 29.5125 35.2938 32.8262V36.1203C35.2938 37.2249 34.3983 38.1203 33.2938 38.1203H14.7055C13.601 38.1203 12.7055 37.2249 12.7055 36.1203V32.8262Z"
  />
</template>
